import Service from "../DepartmentService";

function GetByDepartmentAndTerm(termId) {
    return Service.get('ClassSchedule/GetByDepartmentAndTerm?termId=' + termId);
}



function GetByDepartmentAndTermByMemberId(termId, memberId) {
    return Service.get('ClassSchedule/GetByDepartmentAndTermByMemberId?termId=' + termId + '&memberId=' + memberId);
}

const ClassScheduleService = {
    GetByDepartmentAndTerm,
    GetByDepartmentAndTermByMemberId
};

export default ClassScheduleService;
